import { useContext } from 'react';
import { Maybe } from '~/types';
import { MeContext, MeType } from './context';

export const useMeContext = (): Maybe<MeType> => useContext(MeContext);

export default useMeContext;
